/**
 * Per-tenant module registry. An org enables the "aspects" it needs:
 * a standard NPO enables `seeker`; a grantmaking fund enables
 * `grantmaker` + `fundraising` + `me` + `finance`. Everyone gets the
 * shared core (CRM, documents, deadlines, compliance, dashboards).
 */
export const MODULES = ['seeker', 'grantmaker', 'fundraising', 'me', 'finance'];
export const MODULE_LABELS = {
    seeker: 'Grant Seeking',
    grantmaker: 'Grantmaking',
    fundraising: 'Fundraising',
    me: 'Monitoring & Evaluation',
    finance: 'Finance',
};
export const DEFAULT_MODULES_SEEKER = { seeker: true };
export const DEFAULT_MODULES_FUND = {
    grantmaker: true,
    fundraising: true,
    me: true,
    finance: true,
};
/**
 * Which side of the product a workspace is on. createOrg has stored orgKind
 * since September 2026. A workspace opened before then has none, so it is
 * told apart by its trial, which createOrg chose from the kind (the Fund
 * plan, sold as Grant makers, for a fund; Pro for everyone else), then by a
 * fund plan, and failing those by the modules a fund is created with
 * (grantmaking on, seeking off).
 */
export function orgKindOf(org) {
    if (org.orgKind === 'fund' || org.orgKind === 'seeker')
        return org.orgKind;
    if (typeof org.trialPlan === 'string')
        return org.trialPlan === 'fund' ? 'fund' : 'seeker';
    if (org.plan === 'fund')
        return 'fund';
    return org.modules?.grantmaker === true && org.modules?.seeker !== true ? 'fund' : 'seeker';
}
